/**
 * @generated SignedSource<<4e5605c892abb7aa66b2c2fcbdf11c5c>>
 * @relayHash 9f8e28d0f8d18bbce68dbc943123a0ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 08efba67f706c4b8c3e987443bffc477163e8297cc227d6b595636f7a410cd63

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BoardWithRouterRelayQuery } from './BoardWithRouterRelayQuery.graphql';

const node: PreloadableConcreteRequest<BoardWithRouterRelayQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "08efba67f706c4b8c3e987443bffc477163e8297cc227d6b595636f7a410cd63",
    "metadata": {},
    "name": "BoardWithRouterRelayQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
